import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { restaurants, cantones } from '../data/mockData';
import { Card } from './Card';
interface TopReviewsProps {
  onSelectRestaurant: (id: string) => void;
}
export function TopReviews({
  onSelectRestaurant
}: TopReviewsProps) {
  // Get top-rated restaurants and pull their best review
  const topRestaurants = [...restaurants].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const testimonials = topRestaurants.filter(r => r.reviews.length > 0).map(r => {
    const bestReview = r.reviews.reduce((best, review) => review.rating > best.rating ? review : best);
    const canton = cantones.find(c => c.id === r.cantonId);
    return {
      restaurantId: r.id,
      restaurantName: r.name,
      restaurantImage: r.image,
      cantonName: canton?.name || '',
      rating: bestReview.rating,
      text: bestReview.text,
      author: bestReview.author,
      date: bestReview.date
    };
  });
  return <section className="py-24 px-4 bg-bg-secondary" data-id="element-346">
      <div className="max-w-7xl mx-auto" data-id="element-347">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-348">
          <h2 className="text-4xl md:text-5xl font-heading uppercase tracking-wide text-white mb-4" data-id="element-349">
            Lo que dicen{' '}
            <span className="text-gradient-fire" data-id="element-350">los comensales</span>
          </h2>
          <p className="font-body text-text-secondary text-lg max-w-2xl mx-auto" data-id="element-351">
            Reseñas reales de los restaurantes mejor calificados de la Zona de
            Los Santos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-352">
          {testimonials.map((t, index) => <Card key={t.restaurantId} delay={index * 0.08} className="p-6 flex flex-col" data-id="element-353">
              {/* Quote icon */}
              <QuoteIcon className="w-8 h-8 text-brand-gold/30 mb-4" data-id="element-354" />

              {/* Review text */}
              <p className="font-body text-text-secondary italic leading-relaxed flex-1 mb-6" data-id="element-355">
                "{t.text}"
              </p>

              {/* Stars */}
              <div className="flex gap-0.5 mb-5" data-id="element-356">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < t.rating ? 'text-brand-gold fill-brand-gold' : 'text-border'}`} data-id="element-357" />)}
              </div>

              {/* Author + Restaurant */}
              <div className="flex items-center gap-3 pt-5 border-t border-border cursor-pointer group" onClick={() => onSelectRestaurant(t.restaurantId)} data-id="element-358">
                <img src={t.restaurantImage} alt={t.restaurantName} className="w-11 h-11 rounded-lg object-cover flex-shrink-0" data-id="element-359" />
                <div className="min-w-0" data-id="element-360">
                  <p className="font-body font-bold text-sm text-white" data-id="element-361">
                    {t.author}
                  </p>
                  <p className="font-body text-xs text-text-muted truncate group-hover:text-brand-gold transition-colors" data-id="element-362">
                    sobre {t.restaurantName} · {t.cantonName}
                  </p>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}